<template>
    <div class="main_box">

        <slider @onVertifyDone="handleData"></slider>
        <span>{{checkResult}}</span>

        <trackChart ref="myChart"></trackChart>
    </div>
    
    
</template>

<script>
import slider from './slider.vue'
import trackChart from './trackchart.vue'
export default {
    data(){
        return {
            checkResult:''
        }
    },
    methods:{
        handleData(result){
            this.$refs.myChart.loadData(result.code1)
            this.checkAuth(result)
        },
        checkAuth(data){
            let that = this;
            that.$store.dispatch({
                type: "open/slidervertify",
                showMsg: false,
                params: {
                    zlslidervertifycode:data.code2,
                    urlparams: false
                }
            }).then((res) => {
                this.checkResult = JSON.stringify(res.data);
            });
        }
    },
    mounted(){
    },
    components:{
        trackChart,
        slider
    },
    watch:{

    }
};
</script>

<style lang="less" scoped>
.main_box{
    background-color: white;
    padding: 40px;
}

</style>
